import { useEffect, useState } from 'react'
import {
  ComunicationMailModel,
  ComunicationModel
} from '../../../api/Argentia/model/comunication/comunications'
import { generateIconsFromConfiguration } from '../../../helpers/dataTableActionIconHelper'
import { useHttpError } from '../../../hooks'
import { ActionIcons, DatePeriod } from '../../../model'
import {
  fetchComunication,
  fetchComunications
} from '../../../pages/comunicationCenter/tabs/externals/comunicationExternals.service'
import { getActiveBalanceZone, getActiveCompany } from '../../../redux'
import { comunicationModelListMapper } from './comunicationExternalsTable.mapper'
import { filterApplicableActionsConfiguration } from './comunicationExternalsTable.service'

interface UseExternals {
  externals: ComunicationModel[] | undefined
  mailingList: ComunicationMailModel[] | undefined
  setIdMailingList: React.Dispatch<React.SetStateAction<number | undefined>>
  isFetchingExternals: boolean
  isFetchingMailingList: boolean
  refreshExternals: () => Promise<void>
  createComunication: (
    subjectID: number,
    masterComunicationID: number,
    contractID: number
  ) => Promise<void>
}

interface UseExternalsProps {
  clientID?: number
  dateRange?: DatePeriod
}

export default function useExternals({ dateRange, clientID }: UseExternalsProps): UseExternals {
  const [isFetchingExternals, setIsFetchingExternals] = useState<boolean>(false)
  const [isFetchingMailingList, setIsFetchingMailingList] = useState<boolean>(false)
  const [externals, setExternals] = useState<ComunicationModel[] | undefined>(undefined)

  const [idMailingListSelected, setIdMailingList] = useState<number | undefined>(undefined)
  const [mailingList, setMailingList] = useState<ComunicationMailModel[] | undefined>(undefined)
  const activeBalanceZone = getActiveBalanceZone()?.id
  const activeCompany = getActiveCompany()?.id

  const { showError, clearError, errorProps } = useHttpError()

  const getExternals = async () => {
    const result = await fetchExternals(dateRange, clientID)
    setExternals(comunicationModelListMapper(result))
  }

  const completeDataTableActions = (item: ComunicationModel): ComunicationModel => {
    return {
      ...item,
      actions:
        item.actionsConfiguration &&
        item.actionsConfiguration.length > 0 &&
        generateIconsFromConfiguration(
          item,
          filterApplicableActionsConfiguration(item, item.actionsConfiguration),
          new Map<ActionIcons, Function>([])
        )
    }
  }

  const fetchExternals = async (dateRange?: DatePeriod, clientID?: number) => {
    setIsFetchingExternals(true)
    setExternals(undefined)

    return await fetchComunications(clientID, dateRange?.start, dateRange?.end).then(response => {
      setIsFetchingExternals(false)

      if (response.success) {
        clearError()
        if (response.data !== undefined) {
          return response.data?.map(item => {
            return completeDataTableActions(item)
          })
        } else {
          return []
        }
      } else {
        response.error &&
          showError({
            errorCode: response.error.code,
            onRefresh: async () => {
              // setExternals(await fetchExternals(dateRange))
            }
          })
        return []
      }
    })
  }

  // const fetchExternalsBySubject = async (
  //   subjectID?: number
  // ): Promise<ExternalModel[] | undefined> => {
  //   setIsFetchingExternals(true)
  //   setExternals(undefined)

  //   return await fetchExternalsListItemsBySubject(subjectID).then(response => {
  //     setIsFetchingExternals(false)

  //     if (response.success) {
  //       clearError()
  //       if (response.data !== undefined) {
  //         return response.data?.map((item: ExternalModel) => {
  //           return completeDataTableActions(item)
  //         })
  //       } else {
  //         return []
  //       }
  //     } else {
  //       response.error &&
  //         showError({
  //           errorCode: response.error.code,
  //           onRefresh: async () => {
  //             // setExternals(await fetchExternals(dateRange))
  //           }
  //         })
  //       return []
  //     }
  //   })
  // }

  const fetchMailingList = async (id: number): Promise<ComunicationMailModel[] | undefined> => {
    setIsFetchingMailingList(true)
    setMailingList(undefined)

    return await fetchComunication(id).then(response => {
      setIsFetchingMailingList(false)
      if (response.success) {
        return response.data ?? []
      }
    })
  }

  const createComunication = async (
    subjectID: number,
    masterComunicationID: number,
    contractID: number
  ) => {
    return await createComunication(subjectID, masterComunicationID, contractID).then(response => {
      if (response.success) {
        return response.data ?? []
      }
    })
  }

  useEffect(() => {
    // onNotificationChange(undefined)

    getExternals()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientID, dateRange, activeBalanceZone, activeCompany])

  useEffect(() => {
    const getMailingList = async (id: number) => {
      setMailingList(await fetchMailingList(id))
    }

    if (idMailingListSelected) {
      getMailingList(idMailingListSelected)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idMailingListSelected])

  return {
    externals,
    mailingList,
    setIdMailingList,
    isFetchingExternals,
    isFetchingMailingList,
    refreshExternals: getExternals,
    createComunication
  }
}
